import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { GOOGLE_MAPS_SETTINGS } from '@core/constants';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';

import { GoogleMapsModule } from '@angular/google-maps';
import { ZoomMapDialogComponent } from '../zoom-map-dialog/zoom-map-dialog.component';

@Component({
  selector: 'xemex-branches-map',
  imports: [MatIconModule, GoogleMapsModule],
  templateUrl: './branches-map.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './branches-map.component.scss',
})
export class BranchesMapComponent {
  latitude = input<string>();
  longitude = input<string>();
  height = input<string>('246px');

  options: google.maps.MapOptions = {
    zoom: GOOGLE_MAPS_SETTINGS.zoom,
    draggable: GOOGLE_MAPS_SETTINGS.draggable,
    styles: GOOGLE_MAPS_SETTINGS.styles,
    zoomControl: GOOGLE_MAPS_SETTINGS.zoomControl,
    streetViewControl: GOOGLE_MAPS_SETTINGS.streetViewControl,
    disableDefaultUI: true,
  };
  // Default location Netherlands
  location = { lat: 52.1326, lng: 5.2913 };
  markerOptions: google.maps.MarkerOptions = {
    icon: { url: '/assets/icons/location_on.svg' },
  };

  gmSettings = GOOGLE_MAPS_SETTINGS;

  constructor(private dialog: MatDialog) {
    effect(() => {
      if (this.latitude() && this.longitude()) {
        this.location = {
          lat: +this.latitude()!,
          lng: +this.longitude()!,
        };
      }
    });
  }

  openFullScreenMap(): void {
    this.dialog.open(ZoomMapDialogComponent, {
      width: '920px',
      height: '700px',
      maxWidth: '920px',
      panelClass: 'zoom-map-dialog',
      data: {
        location: this.location,
        options: this.options,
        markerOptions: this.markerOptions,
      },
    });
  }
}
